import { TableCell, TableRow, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { memo } from "react";
import { NumericFormat } from "react-number-format";
import { currencyOf } from "utils/util";
import { TdadosGeneric } from "../pagamento.model";
import { theme } from "theme";

type TLinhaDadosGeneric = {
    index: number;
    row: TdadosGeneric;
    hasError: boolean;
    handleChangeValor: (index: number, valor: number) => void;
    handleDatavencimento: (index: number, vencimentoDisplay: string) => void;
    possuiCondicaoPagamento: boolean;
};


const LinhasDadosGeneric = (props: TLinhaDadosGeneric) => {
    return (
        <TableRow key={props.index} id={`linha-dado-boleto-${props.index}`}>
            <TableCell align="center" >
                <NumericFormat
                    decimalScale={2}
                    fixedDecimalScale
                    defaultValue={0}
                    allowedDecimalSeparators={[',']}
                    customInput={TextField}
                    decimalSeparator=","
                    prefix={'R$ '}
                    thousandsGroupStyle="thousand"
                    thousandSeparator="."
                    variant="standard"
                    allowNegative={false}
                    value={currencyOf(props.row.valor)}
                    error={props.hasError}
                    onValueChange={({ floatValue }) => { props.handleChangeValor(props.index, floatValue ?? 0); }}
                    label='Valor'
                    inputProps={{
                        style: { color: props.hasError ? theme.palette.error.main : '', },
                    }}
                    id={`valor_${props.index}`}
                />
            </TableCell>

            <TableCell >
                <DatePicker
                    slotProps={{
                        textField: {
                            id: `vencimento_${props.index}`,
                            variant: 'standard'
                        }
                    }}
                    label="Vencimento"
                    format='DD/MM/YYYY'
                    onChange={(e: any) => { props.handleDatavencimento(props.index, dayjs(e?.$d).toString() ?? new Date().toString()); }}
                    value={dayjs(props.row.vencimentoDisplay || props.row.vencimento)}
                    minDate={dayjs(new Date())}
                    disabled={props.possuiCondicaoPagamento}
                />
            </TableCell>
        </TableRow>
    );
};

export default memo(LinhasDadosGeneric);
